import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["role"]
const _hoisted_3 = ["inert"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["swiper-container w-full", $options.additionalContainerClasses]),
      ref: "container"
    }, [
      _createElementVNode("ul", {
        class: _normalizeClass(["swiper-wrapper flex flex-nowrap", $options.wrapperClasses]),
        role: $props.isTab ? 'tablist' : null
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.childElements(), (el, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            class: _normalizeClass(["swiper-slide flex-shrink-0 max-w-full", [$props.slideClasses, $data.index === i ? 'slide-active' : '']]),
            inert: $props.fullWidthSlides && $data.index !== i,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.slideClicked && $options.slideClicked(...args)))
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(el)))
          ], 10, _hoisted_3))
        }), 128))
      ], 10, _hoisted_2)
    ], 2),
    (_ctx.$slots.pagination && !$props.editMode)
      ? _renderSlot(_ctx.$slots, "pagination", {
          key: 0,
          index: $data.index + 1,
          total: $options.numSlides,
          teaser: $options.currentSlide,
          go: $options.goTo,
          isPlaying: $data.isPlaying
        })
      : _createCommentVNode("", true),
    (_ctx.$slots.controls)
      ? _renderSlot(_ctx.$slots, "controls", {
          key: 1,
          prev: $options.prev,
          next: $options.next,
          index: $data.index,
          show: $data.prevVisible || $data.nextVisible,
          prevVisible: $data.prevVisible,
          nextVisible: $data.nextVisible,
          isPlaying: $data.isPlaying
        })
      : _createCommentVNode("", true)
  ]))
}